<router-outlet></router-outlet>
<ng-container *ngIf="route.children.length === 0">
    <div class="row">
        <div class="col-xs-12 col-md-10 col-lg-8">
            <div class="card">
                <div class="content">
                    <!-- Main Setup Workflow -->
                    <ng-container [ngSwitch]="workflowState" *ngIf="componentState.isSuccessful()">
                        <!-- Initial -->
                        <ng-container *ngSwitchCase="eWorkflowState.WELCOME">
                            <h1 class="standard-heading">Synchronise your people in Frankli with Sage HR</h1>
                            <div class="standard-description">
                                <span>Take the first step to synchronise your people with Sage HR.</span>
                                <span class="m-right-5"></span>
                                <a target="_blank" href="https://help.frankli.io/en/articles/6292352-how-to-set-up-frankli-s-sage-hr-integration">Learn more.</a>
                            </div>

                            <div class="row"><hr></div>

                            <div class="text-center">
                                <img src="assets/img/UserIDIcon.svg" alt="User">
                            </div>
                            <div>Once synchronised, all your people in Sage HR will be managed and kept up-to-date in Frankli. In the next step you will be asked to provide your <code>Sage HR Company ID</code>, and <code>API Key</code>.</div>

                            <div class="row"><hr></div>

                            <div class="text-center">
                                <app-button (onClick)="workflowState = eWorkflowState.SETUP">Set up Sage HR</app-button>
                            </div>
                        </ng-container>
                        <!-- Set up -->
                        <ng-container *ngSwitchCase="eWorkflowState.SETUP">
                            <h1 class="standard-heading">Synchronise your people in Frankli with Sage HR</h1>
                            <p class="standard-description">
                                In order to connect Frankli with Sage HR, you need to provide your <code>Sage HR Company ID</code>, and <code>API Key</code>.
                                <a target="_blank" href="https://help.frankli.io/en/articles/6292352-how-to-set-up-frankli-s-sage-hr-integration">Learn more.</a>
                            </p>
                            <div class="row">
                                <div class="col-md-12 m-top-15">
                                    <form [formGroup]="setupForm">
                                        <!-- Sage HR Company Id -->
                                        <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown m-bottom-10" [class.frankli-form-group-invalid]="sageHrCompanyId.invalid && setupFormSubmitted">
                                            <label for="sageHrCompanyId">Sage HR Company ID</label>
                                            <input id="sageHrCompanyId" placeholder="Enter Sage HR Company ID here" class="form-control" type="text" [formControl]="sageHrCompanyId">
                                            <div class="frankli-form-group-alert" *ngIf="sageHrCompanyId.invalid && setupFormSubmitted">
                                                <div *ngIf="sageHrCompanyId.hasError('required')">Sage HR Company ID is required</div>
                                                <div *ngIf="sageHrCompanyId.hasError('minlength')">Sage HR Company ID must contain at least 1 character</div>
                                                <div *ngIf="sageHrCompanyId.hasError('maxlength')">Sage HR Company ID must contain less than 255 characters</div>
                                            </div>
                                        </div>

                                        <!-- API Key -->
                                        <div class="frankli-form-group frankli-form-group-filled frankli-form-group-placeholder-shown m-bottom-10" [class.frankli-form-group-invalid]="apiKey.invalid && setupFormSubmitted">
                                            <label for="apiKey">API Key</label>
                                            <input id="apiKey" placeholder="Enter API Key here" class="form-control" type="text" [formControl]="apiKey">
                                            <div class="frankli-form-group-alert" *ngIf="apiKey.invalid && setupFormSubmitted">
                                                <div *ngIf="apiKey.hasError('required')">API Key is required</div>
                                                <div *ngIf="apiKey.hasError('minlength')">API Key must contain at least 1 character</div>
                                                <div *ngIf="apiKey.hasError('maxlength')">API Key must contain less than 255 characters</div>
                                            </div>
                                        </div>

                                        <hr>

                                        <!-- Submit Form -->
                                        <div class="text-center">
                                            <app-button [loading]="setUpFormState.isLoading()" (click)="submitSetupForm()">Complete Set Up</app-button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </ng-container>

                        <!-- Success -->
                        <ng-container *ngSwitchCase="eWorkflowState.SUCCESS">
                            <h1 class="standard-heading">Synchronise your people in Frankli with Sage HR</h1>
                            <div class="standard-description">
                                Your sage HR integration is now connected!
                                <a target="_blank" href="https://help.frankli.io/en/articles/6292352-how-to-set-up-frankli-s-sage-hr-integration">Learn more.</a> 
                            </div>
                            
                            <div class="row"><hr></div>

                            <div class="text-center">
                                <img src="assets/img/thumbs-up-check.svg" alt="Success">
                            </div>
                            <div>Your next step is to trigger your first manual sync with Sage HR, which you can do on the next screen. After that, Frankli will keep your people in sync with Sage HR automatically.</div>

                            <div class="row"><hr></div>

                            <div class="text-center">
                                <app-button (onClick)="workflowState = eWorkflowState.CONFIGURE">Continue</app-button>
                            </div>
                        </ng-container>

                        <!-- Configure -->
                        <ng-container *ngSwitchCase="eWorkflowState.CONFIGURE">
                            <h1 class="standard-heading">Configure Sage HR Integration</h1>
                            <div class="standard-description">On this screen you can monitor your Sage HR integration and check for any synchronisation errors that may occur. <a target="_blank" href="https://help.frankli.io/en/articles/6292352-how-to-set-up-frankli-s-sage-hr-integration">Learn more.</a> </div>

                            <div class="row"><hr></div>

                            <div *ngIf="!sageHrConfiguration?.lastSyncTimestamp && !sageHrConfiguration?.syncing" class="sync-alert">
                                <span><span class="fal fa-circle-exclamation"></span> Looks like you haven't run your first manual sync yet, please click the <span class="fal fa-arrows-rotate"></span> icon below to begin the sync.</span>
                            </div>
                            <div *ngIf="sageHrConfiguration.errors.length > 0" class="sync-alert">
                                <span><span class="fal fa-circle-exclamation"></span> Looks like we encountered some issues during the last sync. Please review the issues below and resolve them in Sage HR before running another manual sync.</span>
                            </div>
                            <div class="card-no-shadow">
                                <div class="row" *ngIf="!sageHrConfiguration.syncing">
                                    <div class="col-md-4 lh-40">
                                        <span class="card-text"><b>Last synced:</b> {{sageHrConfiguration?.lastSyncTimestamp ? (sageHrConfiguration?.lastSyncTimestamp | amLocal | amDateFormat:'DD/MM/yyyy HH:mm') : 'Never'}}</span>
                                    </div>
                                    <div class="col-md-4 lh-40">
                                        <span class="card-text" *ngIf="sageHrConfiguration?.lastSyncTimestamp && sageHrConfiguration?.automaticSyncEnabled"><b>Next sync:</b> {{getNextSyncDateTime() | amLocal | amDateFormat:'DD/MM/yyyy HH:mm'}}</span>
                                        <span class="card-text" *ngIf="sageHrConfiguration?.lastSyncTimestamp && !sageHrConfiguration?.automaticSyncEnabled"><b>Next sync:</b> Never (Automatic Sync Disabled)</span>
                                    </div>
                                    <div class="col-md-4 text-right">
                                        <app-table-action-icon [icon]="'fa-arrows-rotate'" [tooltipPlacement]="'top'" [hoverColor]="eIconHoverColor.GREEN" [tooltipText]="'Begin manual sync'" (click)="confirmBeginManualSync()"></app-table-action-icon>
                                        <ng-container *ngIf="sageHrConfiguration?.lastSyncTimestamp">
                                            <app-table-action-icon *ngIf="sageHrConfiguration.automaticSyncEnabled" [icon]="'fa-pause'" [tooltipPlacement]="'top'" [hoverColor]="eIconHoverColor.YELLOW" [tooltipText]="'Disable automatic sync'" (click)="confirmDisableAutomaticSync()"></app-table-action-icon>
                                            <app-table-action-icon *ngIf="!sageHrConfiguration.automaticSyncEnabled" [icon]="'fa-play'" [tooltipPlacement]="'top'" [hoverColor]="eIconHoverColor.GREEN" [tooltipText]="'Enable automatic sync'" (click)="confirmEnableAutomaticSync()"></app-table-action-icon>
                                        </ng-container>
                                    </div>
                                </div>
                                <div class="text-center" *ngIf="sageHrConfiguration.syncing">
                                    <h5>
                                        <span class="fas fa-spin fa-spinner"></span>
                                        <span class="m-right-5"></span>
                                        <span>Sync in progress...</span>
                                    </h5>
                                </div>
                            </div>

                            <div *ngIf="sageHrConfiguration.errors.length > 0" class="card-no-shadow m-top-15">
                                <h2 class="standard-heading">Sage HR Synchronisation Issues</h2>
                                <div class="standard-description">
                                    <span>For more information on how to resolve the issues below,</span>
                                    <span class="m-right-5"></span>
                                    
                                    <a target="_blank" href="https://help.frankli.io/en/articles/6292352-how-to-set-up-frankli-s-sage-hr-integration">Click here</a>
                                    <span>.&nbsp;</span>
                                    <span>Once you have resolved the issues from this list, please run a manual sync above to fix your people's data in Frankli. We will then check if the issues have been resolved and remove them from this list if they have.</span>
                                </div>
                                <div class="card-headers">
                                    <div class="row">
                                        <div class="col-md-3">
                                            <h5>Timestamp</h5>
                                        </div>
                                        <div class="col-md-5">
                                            <h5>Name/Identifier</h5>
                                        </div>
                                        <div class="col-md-4">
                                            <h5>Error Code</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="scroll-x errors-container">
                                    <div class="sync-error-item" *ngFor="let syncError of sageHrConfiguration.errors">
                                        <div class="card-shadow">
                                            <div class="row">
                                                <div class="col-md-3">
                                                    <span>{{syncError.timestamp | amLocal | amDateFormat:'DD/MM/yyyy HH:mm'}}</span>
                                                </div>
                                                <div class="col-md-5">
                                                    <span>{{syncError.entityName ? syncError.entityName : 'N/A'}}</span>
                                                </div>
                                                <div class="col-md-4">
                                                    <span>{{syncError.code}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="row"><hr></div>

                            <div class="text-center m-top-20">
                                <app-button [type]="eButtonType.RED_INVERTED" [loading]="componentState.isLoading()" (click)="confirmDeleteConfiguration()">Delete Configuration</app-button>
                            </div>
                        </ng-container>
                    </ng-container>

                    <!-- Other page states -->
                    <app-loading-state *ngIf="componentState.isLoading()" [height]="'300px'"></app-loading-state>
                    <app-error-state *ngIf="componentState.isFailure()" [message]="componentState.error.message"></app-error-state>
                </div>
            </div>
        </div>
    </div>
</ng-container>